import { useSiteContent } from "@/context/SiteContentContext";

export default function AnnouncementStrip() {
  const { t } = useSiteContent();
  if (t("live.announcement.visible", "true") === "false") return null;
  const text = t("live.announcement.text", "Live now — limited-time exhibitor showcases, only on CityShor Pop Up Bazaar.");
  const bg = t("live.announcement.bg", "#111827");
  if (!text.trim()) return null;
  return (
    <div data-testid="announcement-strip" className="w-full" style={{ background: bg }}>
      <div className="mx-auto max-w-7xl px-4 lg:px-8 py-2 text-center text-xs sm:text-sm text-white font-medium">{text}</div>
    </div>
  );
}
